<template>
  <div
    class="notice-detail-box-in"
    :style="{ cursor: type == 1 ? 'pointer' : '' }"
    @click="type == 1 ? toDetail() : ''"
  >
    <div class="purchase-class materials">
      {{ data.schemeClassName }}{{ $t("page.content.purchase") }}
    </div>
    <div class="scheme-name ell-2" :title="`${data.noticeTitle}`">
      {{ data.noticeTitle }}
      <!-- <div class="triangle-box">
        <div class="triangle"></div>
        <span class="type-tag">{{
          data.purchaseTypeName.replace(/\(/g, "").slice(0, 2)
        }}</span>
      </div> -->
    </div>
    <div
      class="class-name ell color-1"
      :title="
        `${
          data.bigClassName[0] ? data.bigClassName.join(',') : data.engineerType
        }`
      "
    >
      <!-- :title="`${data.bigClassName[0] ? data.bigClassName.join(',') : '其他'}`" -->
      {{
        data.bigClassName[0] ? data.bigClassName.join(",") : data.engineerType
      }}
    </div>
    <p :class="`purchase-class ${'equipment'}`">
      <span class="tip" v-if="data.purchaseType != 5">{{
        data.purchaseTypeName
      }}</span>
      <span class="tip" v-else>{{ data.purchaseTypeName || "" }}</span>
    </p>
    <div class="pt5 pl4 dis-flex">
      <span
        class="color-1 item-attr ell"
        :title="$t('page.content.ProjectName')"
        >{{ $t("page.content.ProjectName") }}</span
      >：
      <span class="ell item-span" :title="data.schemeName">{{
        data.schemeName
      }}</span>
    </div>
    <div class="pl4 pt3 dis-flex">
      <span
        class="color-1 item-attr ell"
        :title="$t('page.content.Supplier')"
        >{{ $t("page.content.Supplier") }}</span
      >：
      <span class="ell item-span" :title="data.supName">{{
        data.supName
      }}</span>
    </div>
    <div class="pl4 pt3 dis-flex">
      <span class="color-1 item-attr ell" :title="$t('page.content.Publish')">{{
        $t("page.content.Publish")
      }}</span
      >：
      <span
        class="ell item-span"
        :title="moment(data.noticeStartTime).format('YYYY-MM-DD HH:mm')"
        >{{ moment(data.noticeStartTime).format("YYYY-MM-DD HH:mm") }}</span
      >
    </div>
    <div class="pl4 pt3 dis-flex" style="min-height: 22px;">
      <template v-if="!!data.totalNum">
        <span
          class="color-1 item-attr ell"
          :title="$t('page.content.packageNum')"
          >{{ $t("page.content.packageNum") }}</span
        >：
        <span class="ell item-span" :title="data.totalNum">{{
          data.totalNum
        }}</span>
      </template>
    </div>
    <div class="pl4 pt3 dis-flex" style="min-height: 22px;">
      <template>
        <span
          class="color-1 item-attr ell"
          :title="$t('page.content.baojiaNum')"
          >{{ $t("page.content.baojiaNum") }}</span
        >：
        <span class="ell item-span" :title="data.priceNum">{{
          data.priceNum
        }}</span>
      </template>
    </div>
    <div class="dotted-line"></div>
    <div class="time">
      <template v-if="type == 3">
        <span class="timeIcon"><img :src="timeImg" alt=""/></span>
        <!--<span>{{ $t("page.content.tender") }}</span>-->
        <span>
          {{
            data.schemeStatus == 3
              ? $t("page.content.performing")
              : $t("page.content.completed")
          }}
        </span>
      </template>
      <template v-else>
        <span class="timeIcon"><img :src="timeImg" alt=""/></span>
        <span
          >{{ $t("page.content.end")
          }}<span>{{ data.noticeEndTime | day }}</span
          >{{ $t("page.content.day") }}</span
        >
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import timeImg from "@/basa/assets/images/time.png";
export default {
  name: "noticeItemBlock",
  data() {
    return {
      moment,
      timeImg: timeImg
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          schemeClass: "1",
          schemeClassName:
            this.data.supplierFlag + "" === "0" ? "物资" : "分包",
          noticeTitle: "1215545454",
          bigClassName: ["12522"],
          schemeName: "名称",
          schemeCode: "编号",
          noticeStartTime: "时间",
          totalNum: "数量",
          noticeStatusName: "noticeStatusName"
        };
      }
    },
    type: {
      type: String,
      default: "2"
    }
  },
  methods: {
    toDetail() {
      // let row = this.data;
      // this.$router.push({
      //   path: "/shop/viewNoticeDetail",
      //   query: {
      //     schemeId: row.schemeId,
      //     noticeId: row.noticeId,
      //     opUnitName: row.opUnitName,
      //     opUnitId: row.opUnitId,
      //     purchaseType: row.purchaseType,
      //     noticeEndTime: row.noticeEndTime,
      //     noticeStartTime: row.noticeStartTime,
      //     schemeName: row.schemeName,
      //     schemeCode: row.schemeCode
      //   }
      // });
      console.log(this.data, "data");
    }
  }
};
</script>

<style scoped lang="scss">
.time {
  display: flex;
  .timeIcon {
    width: 14px;
    height: 14px;
    color: #0089ef;
    padding-top: 3px;
    padding-right: 10px;
    img {
      height: 14px;
      width: 14px;
      display: inline-block;
    }
  }
  span {
    color: #999999;
    span {
      color: red;
      padding: 0 3px;
    }
  }
}
.pt3 {
  padding-top: 3px;
}
.item-attr {
  max-width: 96px;
  text-align: left;
}
.item-span {
  max-width: 112px;
  display: inline-block;
}
.dis-flex {
  display: flex;
}
.triangle-box {
  display: flex;
  float: right;
}
.triangle {
  width: 0;
  height: 0;
  border-bottom: 3px solid red;
  border-left: 4px solid transparent;
  position: relative;
  bottom: -19px;
}
</style>
